/* eslint-disable jsx-a11y/label-has-associated-control */
import Typo from 'components/Typo';
import { useFormikContext, FormikErrors } from 'formik';
import User from 'models/auth/@types';
import TextField from '../../components/FormFields/TextField';
import { STUDENT_INFO_KEYS as KEYS } from './constants';
import styles from './userEditForm.module.sass';

interface StudentInfoErrors {
  student_info?: {
    guardian_name?: string;
    guardian_email?: string;
    teacher_name?: string;
    teacher_email?: string;
  };
}

const StudentInfoFields = () => {
  const { values, handleChange, handleBlur, errors } = useFormikContext<User>();
  const typedErrors = errors as FormikErrors<User> & StudentInfoErrors;
  return (
    <div className={styles.studentInfoFields}>
      <div className={styles.studentInfoFields__guardian}>
        <label>
          <Typo>Guardian Information</Typo>
        </label>
        <TextField
          valueKey={KEYS.guardianNameKey}
          type="text"
          otherFieldProps={{
            placeholder: 'Guardian Name',
            onChange: handleChange,
            onBlur: handleBlur,
            value: values.student_info?.guardian_name,
          }}
        />
        <TextField
          valueKey={KEYS.guardianEmailKey}
          type="text"
          otherFieldProps={{
            placeholder: 'Guardian Email',
            onChange: handleChange,
            onBlur: handleBlur,
            value: values.student_info?.guardian_email,
          }}
          error={typedErrors.student_info?.guardian_email}
        />
      </div>
      <div className={styles.studentInfoFields__teacher}>
        <label>
          <Typo>Teacher Information</Typo>
        </label>
        <TextField
          valueKey={KEYS.teacherNameKey}
          type="text"
          otherFieldProps={{
            placeholder: 'Teacher Name',
            onChange: handleChange,
            onBlur: handleBlur,
            value: values.student_info?.teacher_name,
          }}
          error={typedErrors.student_info?.teacher_name}
        />
        <TextField
          valueKey={KEYS.teacherEmailKey}
          type="text"
          otherFieldProps={{
            placeholder: 'Teacher Email',
            onChange: handleChange,
            onBlur: handleBlur,
            value: values.student_info?.teacher_email,
          }}
          error={typedErrors.student_info?.teacher_email}
        />
      </div>
    </div>
  );
};

export default StudentInfoFields;
